import * as React from 'react'

import { cn } from '../../../lib/utils'

export interface InfoItem {
  label: string
  value: React.ReactNode
}

export function InfoStrip({ items, className }: { items: InfoItem[]; className?: string }) {
  if (items.length === 0) return null
  return (
    <div className={cn('flex flex-wrap gap-x-8 gap-y-3', className)}>
      {items.map((item, i) => (
        <div key={`${item.label}-${i}`} className="flex flex-col gap-0.5">
          <span className="text-11 font-medium uppercase tracking-[0.06em] text-ink-4">
            {item.label}
          </span>
          <span className="text-sm text-ink">{item.value}</span>
        </div>
      ))}
    </div>
  )
}
